export const accessibilityOptionsMap = new Map<string, string>([
  ["Wheelchair", "Wheelchair"],
  ["WheelchairCanTransferToSeat", "Wheelchair - can transfer to seat"],
  ["DifficultyWithStairs", "Difficulty with stairs"],
  ["Vision", "Vision impairments"],
  ["Hearing", "Auditory impairments"],
  ["Epileptic", "Epileptic"],
  ["Other", "Other"]
]);

export const accessibilityOptionsMapWithNone = new Map<string, string>([
  ["None", "None"],
  ...accessibilityOptionsMap,
]);

type AccessibilityOption = {
  [key: string]: string;
};

export const accessibilityOptions: AccessibilityOption = {
  None: "None",
  Wheelchair: "Wheelchair",
  WheelchairCanTransferToSeat: "Wheelchair, can transfer to seat",
  DifficultyWithStairs: "Difficulty with stairs",
  Vision: "Vision impairments",
  Hearing: "Auditory impairments",
  Epileptic: "Epileptic",
};

export const accessibilityOptionsWithOther = {
  ...accessibilityOptions,
  Other: "Other"
}

export enum AccessibilityTypeEnum {
  wheelchair = "Wheelchair",
  wheelchairCanTransferToSeat = "WheelchairCanTransferToSeat",
  difficultyWithStairs = "DifficultyWithStairs",
  vision = "Vision",
  hearing = "Hearing",
  epileptic = "Epileptic",
  other = "Other",
}

export const AccessibilityTextsMap: Map<AccessibilityTypeEnum, string> = new Map([
  [AccessibilityTypeEnum.wheelchair, "Accessibility - Wheelchair"],
  [AccessibilityTypeEnum.wheelchairCanTransferToSeat, "Wheelchair - Can transfer to seat"],
  [AccessibilityTypeEnum.difficultyWithStairs, "Difficulty with stairs"],
  [AccessibilityTypeEnum.vision, "Accessibility - Vision"],
  [AccessibilityTypeEnum.hearing, "Accessibility - Hearing"],
  [AccessibilityTypeEnum.epileptic, "Accessibility - Epileptic"],
  [AccessibilityTypeEnum.other, "Other"],
]);